module.exports = {
  api_url: 'https://api.sctajik.com/api/v2',
  cas_url: 'https://cas.sctajik.com',
  www_url: 'https://oao.sctajik.com',
  ase_url: 'https://t-ase.com/'
}
